import React from "react";
import styled from "styled-components";
import { Card, CardActions, Typography, Table, TableCell, TableBody, TableRow, CardHeader, CardContent, Chip } from "@material-ui/core";
import Theme from "../../Theme";
import { sortRows } from "../tables/helperFuncs";
import { formatDescription } from "../../functions/serviceCallFunctions";
import IServiceCallNote from "../../models/IServiceCallNote";
import { IHeaderCell } from "../tables/TableHeader";

const StyledCard = styled(Card)`
  max-width: 1200px;
`;

const StyledCardActions = styled(CardActions)`
  padding-left: 16px;
`;

const StyledSkywardCardActions = styled(StyledCardActions)`
  background-color: ${Theme.colors.darkBackground};
`;

const StyledCustomerCardActions = styled(StyledCardActions)`
  background-color: ${Theme.colors.buttonSecondary};
`;

const StyledTypography = styled(Typography)`
  margin-left: auto;
  padding-right: 16px;
  font-weight: 500;
  color: ${Theme.colors.white};
`;

const StyledTable = styled(Table)`
  max-width: 1200px;
`;

const StyledPaperTableCell = styled(TableCell)`
  border-bottom: 0px;
  max-width: 1200px;
`;

const H2 = styled.h2`
  padding-left: 16px;
  margin-block-start: 0;
  margin-block-end: 0;
`;

const StyledToolbarTableCell = styled(TableCell)`
  padding: 16px;
`;

const StyledChip = styled(Chip)`
  background-color: ${Theme.colors.white};
`;

interface ISCNoteProps {
  notes: IServiceCallNote[];
}

function getActionCard(type: string, dateSubmitted: string) {
  if (type === "Response") {
    return (
      <StyledCustomerCardActions>
        <StyledChip size="small" label={type} />
        <StyledTypography variant="caption">{dateSubmitted}</StyledTypography>
      </StyledCustomerCardActions>
    );
  } else {
    return (
      <StyledSkywardCardActions>
        <StyledChip size="small" label={type} />
        <StyledTypography variant="caption">{dateSubmitted}</StyledTypography>
      </StyledSkywardCardActions>
    );
  }
}

export default function SCDetailNotes(props: ISCNoteProps) {
  const cell: IHeaderCell<IServiceCallNote> = {
    propName: "dateSubmitted",
    label: "Date Submitted",
    numeric: false,
    order: "desc",
    date: true,
  };

  return (
    <>
      <StyledTable>
        <TableBody>
          <TableRow>
            <StyledToolbarTableCell>
              <H2>Notes</H2>
            </StyledToolbarTableCell>
          </TableRow>
        </TableBody>
      </StyledTable>

      <StyledTable>
        <TableBody>
          {sortRows(props.notes, cell).map(scn => {
            return (
              <TableRow key={scn.noteID}>
                <StyledPaperTableCell>
                  <StyledCard elevation={2}>
                    <CardHeader title={scn.summary} />
                    <CardContent>
                      <Typography variant="body2" component="div">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatDescription(scn.detail),
                          }}
                        />
                      </Typography>
                    </CardContent>
                    {getActionCard(scn.type, scn.dateSubmitted)}
                  </StyledCard>
                </StyledPaperTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </StyledTable>
    </>
  );
}
